import { inject, Injectable, computed, Injector } from "@angular/core";

import type { BaseFilterDefinition } from "@shared/filter";
import { DynamicFilterMulti } from "./types";
import type { IBaseT1Card } from "@app/views-interfaces";
import { IFirmRolesService } from "@shared";
import type { DynamicFilters, FilterMultiSelection } from "@filter/filter.types";
import { AssigneeFilter } from "./assignee";

@Injectable()
export class AssigneesFilterService extends DynamicFilterMulti<IBaseT1Card> {
    private readonly injector = inject(Injector);
    private readonly iFirmRolesService = inject(IFirmRolesService);

    protected getDefinitionInfo(): BaseFilterDefinition {
        return {
            filterName: "Assignees",
            label: "AllView.JobsAndBilling.AssignedRoles.CurrentlyResponsible",
        };
    }

    protected readonly filtersByName = computed<DynamicFilters<FilterMultiSelection, IBaseT1Card>>(() => {
        const filters: DynamicFilters<FilterMultiSelection, IBaseT1Card> = new Map();

        const rolesWithUsers = this.iFirmRolesService.rolesWithUsers();
        if (!rolesWithUsers?.size) return filters;

        rolesWithUsers.forEach((_, roleId) => {
            let assignee = this.filtersCached.get(roleId);

            if (!assignee) {
                assignee = new AssigneeFilter(this.injector, roleId, this.iFirmRolesService.rolesWithUsers);
                this.filtersCached.set(roleId, assignee);
            }

            filters.set(roleId, assignee);
        });

        const currentRoleIds = new Set(rolesWithUsers.keys());
        for (const cachedRoleId of this.filtersCached.keys()) {
            if (!currentRoleIds.has(cachedRoleId)) this.filtersCached.delete(cachedRoleId);
        }

        return filters;
    });
}
